import { uploadStoredAttachment, uploadStoredAttachments } from '../services/uploadService';

export const readFilesAsStoredAttachments = async (fileList, uploadedBy = 'System', context = {}) =>
  uploadStoredAttachments(fileList, uploadedBy, context);

export const readFileAsStoredAttachment = async (file, uploadedBy = 'System', context = {}) =>
  uploadStoredAttachment(file, uploadedBy, context);
